module.exports = __webpack_public_path__ + "img/sample-photo-2.e48952f6.png";